function onInput(e) {
  const el  = e.target;

  let min           = parseInt(el.min  , 10),
      max           = parseInt(el.max  , 10),
      originalValue = el.value + '',
      value         = originalValue;

  // 全角数字を半角に変換
  value = value.replace(/[！-～]/g,
    function(tmpStr) {

      // 文字コードをシフト
      return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
    }
  );

  // 数字以外を削除
  value = value.replace(/[^0-9]/g, '');

  // 0処理
  //   0以外の入力があれば先頭の0を全部削除
  //   0だけであれば連続0を1つにする
  value = value.replace(/^0+/, /[1-9]/.test(value) ? '' : '0');

  value = parseInt(value, 10);

  min   = isNaN(min  ) ? null : min;
  max   = isNaN(max  ) ? null : max;
  value = isNaN(value) ? null : value;

  if (value === null) {
    value = '';
  } else {
    if (min !== null && value < min) {
      value = min;
    } else if (max !== null && value > max) {
      value = max;
    }
    value = String(value);
  }

  if (value !== originalValue) {
    el.value = value;
    const event = document.createEvent('Event');
    event.initEvent('input', true, true);
    el.dispatchEvent(event);
  }
}

function bindNumberInRange(el, binding, vnode) {
  el.addEventListener('input', onInput, false);
}



export default {
  bind(el, binding, vnode) {
    bindNumberInRange(el, binding, vnode);
  },

  componentUpdated(el, binding, vnode) {
    bindNumberInRange(el, binding, vnode);
  },
}


// WEBPACK FOOTER //
// ./src/js/ui/directives/number-range.js